import {
  useTranslation,
  Col,
  useShowToastNotification,
  ENotificationType,
  TRtkErrorType,
} from '@packages/utils';
import { useTheme } from 'styled-components';
import { EIconNames, Icon } from 'components/Base/Icon';
import { useDeleteMeetingMutation } from 'redux/apiSlice/elcs.slice';
import { TRemoveMeetingProps } from 'pages/private/ELCs/ELCDetail/components/MeetingsTab/MeetingsActions/RemoveMeeting/RemoveMeeting.types';

const RemoveMeeting = ({ meetingId, elcId }: TRemoveMeetingProps) => {
  const theme = useTheme();
  const { showToastNotification } = useShowToastNotification();
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.elcs.detail.meetings-tab.list.actions.delete',
  });
  const [deleteMeeting, { isLoading }] = useDeleteMeetingMutation();

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    if (isLoading) {
      e.preventDefault();
      return;
    }
    try {
      const payload: any = {
        meetingId,
      };

      if (elcId) {
        const sanitizedElcId = elcId.replace(/"/g, '');
        payload.elcId = sanitizedElcId;
      }

      await deleteMeeting(payload).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (err) {
      showToastNotification({
        message: (err as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Col onClick={handleSubmit}>
      <Icon
        icon={EIconNames.DELETE_OUTLINED}
        color={theme.colorBlackIconColor}
        className="pointer"
        tooltip={{ title: t('DELETE_TOOLTIP') }}
      />
    </Col>
  );
};

export default RemoveMeeting;
